/**
 * Labels the protocol analysis found on a visit that matched no real form.
 * They wait on the visit as `formsToConfirm` until someone assigns a form on
 * Form Assignments. Pure, so it is tested without React.
 */
export interface VisitWithConfirm {
  id: string;
  name?: string;
  formsToConfirm?: unknown;
}

export interface FormsToConfirmEntry {
  visitId: string;
  visitName: string;
  labels: string[];
}

export function formsToConfirmSummary(visits: VisitWithConfirm[] | undefined | null): FormsToConfirmEntry[] {
  const out: FormsToConfirmEntry[] = [];
  for (const v of visits ?? []) {
    if (!Array.isArray(v.formsToConfirm)) continue;
    const seen = new Set<string>();
    const labels: string[] = [];
    for (const l of v.formsToConfirm) {
      if (typeof l !== "string") continue;
      const t = l.trim();
      if (!t || seen.has(t)) continue;
      seen.add(t);
      labels.push(t);
    }
    if (labels.length) out.push({ visitId: v.id, visitName: v.name || v.id, labels });
  }
  return out;
}
